import { Controller } from "stimulus"

export default class extends Controller {
  static values = { containerId: String }

  download() {
    const container = document.getElementById(this.containerIdValue)
    if (!container) return

    const img = container.querySelector(".generated-image")
    if (!img) return

    const link = document.createElement("a")
    link.href = img.src
    link.download = `generated-image-${Date.now()}.png`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  regenerate() {
    const container = document.getElementById(this.containerIdValue)
    if (!container) return

    const promptEl = container.querySelector(".generated-image-prompt em")
    if (!promptEl) return

    const textarea = document.getElementById("chatPromptField")
    if (!textarea) return

    textarea.value = promptEl.textContent
    textarea.focus()
    textarea.dispatchEvent(new Event("input", { bubbles: true }))
    textarea.dispatchEvent(new Event("keyup", { bubbles: true }))
  }
}
